import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Subscribe} from 'unstated';
import InvoiceDataContainer from '../../Stores/InvoiceDataContainerStore';

class SupplierLogoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.invdata = null;
  }
  componentDidMount() {
    if (this.invdata.state.loading && this.props.history) this.props.history.replace(`/loading`);
  }
  renderLogo = (data) => {
    if (data.state.failed) {
    	this.props.history && this.props.history.replace(`/error`);
    } else if (
      data.state.context != undefined &&
      data.state.context.localeCompare("top_build_paythroughemail") === 0
    ) {
      this.props.history.replace(`/genericpaythroughemail`);
    } else if (
      data.state.context != undefined &&
      data.state.context.localeCompare("top_build_paymentonaccount") === 0
    ) {
      this.props.history.replace(`/genericpaymentonaccount`);
    } else if (data.state.loading)
      return data.validateAndPopulateSupplierLogo();
    else
      return (
        <img
          className="invoice-account-logo"
          src={data.validateAndPopulateSupplierLogo()}
          alt="logo"
        />
      );
  };
  setInvData = (data) => {
    this.invdata = data;
  };
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(data) => (
          <Row className="invoice-account-logo-container-row">
            {this.setInvData(data)}
            <Col className="invoice-account-logo-container">
              {this.renderLogo(data)}
            </Col>
          </Row>
        )}
      </Subscribe>
    );
  }
}
export default SupplierLogoContainer;
